import { Card, Typography, Space, Row, Col, Button } from "antd";
import { EditOutlined } from "@ant-design/icons";
import { CustomerCardComponentModel } from "@services/api";
import { bxOpenSlider } from "@lib/bx24";

const copyableConfig = {
  tooltips: false,
};

interface Props {
  customer?: CustomerCardComponentModel;
  className?: string;
}

const InfoItem: React.FC<{ label: string; value?: string }> = ({ label, value }) => (
  <Space size="small">
    <Typography.Text type="secondary">
      {label}: {value ? <Typography.Text copyable={copyableConfig}>{value}</Typography.Text> : "—"}
    </Typography.Text>
  </Space>
);

export default function CustomerCard({ customer, className }: Props) {
  const handleOpen = () => bxOpenSlider("customer", { customerId: customer?.customerId });

  return (
    <Card className={className} bordered>
      <Row justify="space-between" align="top" gutter={16} style={{ marginBottom: 8 }}>
        <Col flex="auto">
          <Typography.Title level={5} style={{ margin: 0, wordBreak: "break-word" }}>
            {customer?.displayName || customer?.shortName || customer?.fullName || "—"}
          </Typography.Title>
        </Col>
        <Col flex="none">
          <Button type="primary" icon={<EditOutlined />} onClick={handleOpen}>
            Править анкету
          </Button>
        </Col>
      </Row>

      <Space size="large">
        <InfoItem label="ИНН" value={customer?.inn} />
        <InfoItem label="ОГРН" value={customer?.ogrn} />
        <InfoItem label="КПП" value={customer?.kpp} />
      </Space>
    </Card>
  );
}
